module.exports = __webpack_public_path__ + "static/media/female-customer-rate-and-tip_2x.3547f095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/female-customer-rate-and-tip_2x.png
// module id = 1168
// module chunks = 27